import { computed, ref } from '@vue/composition-api'
import { isNavLinkActive, navLinkProps } from '@hw-ui/layouts/utils'
import store from '@/shared/store'

export default function useVerticalNavMenuLink(item) {
  const isActive = ref(false)
  const badge = ref(0)
  const selectedAccount = computed(() => store.state.appAccount.selectedAccount)
  const user = computed(() => store.state.appAuth.authUser)
  const accountId = selectedAccount.value.value.id
  const linkProps = navLinkProps(item)

  const updateIsActive = () => {
    isActive.value = isNavLinkActive(item)
  }
  if (item.watchBadgeCount) {
    item.watchBadgeCount({
      role: user.value.role,
      onlyAreas: user.value.role === 'customer' && user.value.areas ? user.value.areas : null,
      accountId: user.value.role === 'customer' ? accountId : null,
      callback: change => {
        if (change.type === 'added') {
          badge.value += 1
        }
        if (change.type === 'removed') {
          badge.value -= 1
        }
      },
    })
  }
  if (item.setBadgeCount) {
    item.setBadgeCount({
      accountId: user.value.role === 'customer' ? accountId : null,
      role: user.value.role,
      onlyAreas: user.value.role === 'customer' && user.value.areas ? user.value.areas : null,
      callback: count => {
        badge.value = count
      },
    })
  }

  return {
    isActive,
    linkProps,
    badge,
    updateIsActive,
  }
}
